// extracted by mini-css-extract-plugin
export default {"not-cancelable":"cancel-subscription-block_not-cancelable__kgzU-","buttonCancel":"cancel-subscription-block_buttonCancel__kOOMT"};